import type { ReactNode } from 'react';

export const symbol_book_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-320q15-10 32.5-15t37.5-5h30v-480h-30q-29.17 0-49.58 20.42Q220-779.17 220-750v430Zm160-20h360v-480H380v480Zm-160 20v-500 500Zm70 240q-53.86 0-91.93-38.07Q160-156.14 160-210v-540q0-53.86 38.07-91.93Q236.14-880 290-880h450q24.75 0 42.38 17.62Q800-844.75 800-820v515q0 9.14-5 16.57T781-277q-19 8-30 25.77-11 17.76-11 41 0 23.23 10.93 40.82Q761.87-151.82 781-144q9 4 14 13t5 21q0 12.44-8.62 21.22Q782.75-80 770-80H290Zm-.46-60H699q-9-15-14-33t-5-37q0-20 5-37.5t15-32.5H289.61q-28.61 0-49.11 20.42Q220-239.17 220-210q0 29 20.5 49.5t49.04 20.5Z"
		/>
	</svg>
);
